"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgCloseCircleFilled = function (props) {
    var color = props.color;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM8.777 16.61l3.202-3.188 3.244 3.23c.434.434 1.107.466 1.501.073.395-.392.362-1.062-.073-1.495L13.407 12l3.244-3.23c.435-.433.468-1.103.073-1.496-.394-.392-1.066-.36-1.501.073l-3.245 3.23-3.2-3.187a1.143 1.143 0 0 0-1.023-.327.938.938 0 0 0-.48.254c-.394.393-.361 1.063.074 1.496L10.55 12l-3.201 3.187c-.435.433-.468 1.103-.073 1.496.394.392 1.066.36 1.501-.073Z", fill: color }));
};
exports.default = factorySvgIcon_1.default(SvgCloseCircleFilled);
//# sourceMappingURL=SvgCloseCircleFilled.js.map